

import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import axios from "axios";

const CateringImageCard = ({ src, isMobile }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ padding: isMobile ? 5 : 10, outline: "none" }}
    >
      <div
        style={{
          height: isMobile ? 200 : 300,
          borderRadius: 16,
          overflow: "hidden",
          boxShadow: hovered
            ? "0 16px 30px rgba(0,0,0,0.2)"
            : "0 12px 25px rgba(0,0,0,0.1)",
          transition: "transform 0.3s, box-shadow 0.3s",
          cursor: "pointer",
          transform: hovered ? "translateY(-4px)" : "translateY(0)",
        }}
      >
        <img
          src={src}
          alt="gallery"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            transform: hovered ? "scale(1.05)" : "scale(1)",
            transition: "transform 0.4s ease-in-out",
          }}
        />
      </div>
    </div>
  );
};

const CateringGalleryCards = () => {
  const [vendorId, setVendorId] = useState(null);
  const [images, setImages] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setVendorId(localStorage.getItem("vendorId"));
  }, []);

  const toSrc = (raw) => {
    if (!raw) return null;
    if (raw.startsWith("data:") || raw.startsWith("http")) return raw;
    if (raw.includes(".")) {
      const HOST = "http://10.10.20.9:6300";
      return raw.startsWith("/") ? HOST + raw : `${HOST}/${raw}`;
    }
    return `data:image/jpeg;base64,${raw}`;
  };

  useEffect(() => {
    if (!vendorId) return;
    const token = localStorage.getItem("authToken");

    (async () => {
      try {
        const { data } = await axios.get(
          `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/aboutus/${vendorId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const imgs = [data.image1, data.image2, data.image3, data.image4]
          .filter(Boolean)
          .map(toSrc);
        setImages(imgs);
      } catch (err) {
        console.error("❌ Unable to load gallery images:", err);
      }
    })();
  }, [vendorId]);

  const sectionStyle = {
    margin: "0 auto",
    padding: "20px",
    maxWidth: "1200px",
  };

  const titleStyle = {
    textAlign: "center",
    fontSize: isMobile ? 28 : 38,
    fontWeight: 800,
    letterSpacing: 1,
    textTransform: "uppercase",
    textShadow: "0 4px 6px rgba(0,0,0,.1)",
    marginBottom: isMobile ? 20 : 30,
  };

  return (
    <section style={sectionStyle}>
      <h1 style={titleStyle}>
        <span style={{ color: "red" }}>Gall</span>
        <span style={{ color: "rgb(42 9 71)" }}>ery</span>
      </h1>

      <Swiper
        modules={[Autoplay]}
        spaceBetween={isMobile ? 10 : 20}
        slidesPerView={isMobile ? 1 : 4}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 4 },
        }}
      >
        {images.map((src, idx) => (
          <SwiperSlide key={idx}>
            <CateringImageCard src={src} isMobile={isMobile} />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default CateringGalleryCards;





